import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IItemObservation, IItemObservationFilter, IItemsObservationsPagination, IItemsObservationsState, IItemObservationRemoveFailureActionPayload, IItemsObservationSave, } from './types'


const initialState: IItemsObservationsState = {
  data: [],
  pagination: {
    count: 0,
    countFiltered: 0,
  },
  isLoading: false
}

export const itemsObservationsSlice = createSlice({
  name: 'observations',
  initialState,
  reducers: {
    itemsObservationsListRequest: (state, action?: PayloadAction<IItemObservationFilter | undefined>) => {
      state.isLoading = true
      state.error = undefined;
    },
    itemsObservationsListSuccess: (state, action: PayloadAction<IItemObservation[]>) => {
      state.data = action.payload
      state.isLoading = false
    },
    itemsObservationsListFailure: (state, action: PayloadAction<ISystemErrors>) => {
      state.error = action.payload
      state.isLoading = false
    },
    startEditingItemObservation: (state, action: PayloadAction<IItemObservation>) => {
      state.draftItemObservation = action.payload;

    },
    stopEditingItemObservation: (state) => {
      state.draftItemObservation = undefined;
    },
    itemObservationDraftUpdate: (state, action: PayloadAction<IItemObservation>) => {
      state.draftItemObservation = action.payload;

    },
    itemsObservationsSaveRequest: (state, action: PayloadAction<IItemObservation>) => {
      if (state.draftItemObservation) {
        state.draftItemObservation.isSaving = true;
        state.draftItemObservation.error = undefined;
      }
      state.error = undefined;
    },
    itemsObservationsSetPagination: (state, action: PayloadAction<IItemsObservationsPagination>) => {
      state.pagination = action.payload

    },
    itemsObservationsSaveSuccess: (state, action: PayloadAction<IItemObservation>) => {
      const oldItemObservation = state.data.find(itemObservation => itemObservation.id === action.payload.id)

      if (!oldItemObservation) {
        state.data.push({
          ...action.payload,
          error: undefined
        })
        state.data = state.data.sort((a, b) => a.observation.localeCompare(b.observation));
      }
      else {
        state.data = state.data.map(itemObservation => {
          if (itemObservation.id !== action.payload.id) return itemObservation;

          return {
            ...itemObservation,
            ...action.payload,

            isSaving: false,
            error: undefined
          }

        }).sort((a, b) => a.observation.localeCompare(b.observation));
      }
      state.draftItemObservation = undefined;
      state.error = undefined;
    },

    itemsObservationsSaveFailure: (state, action: PayloadAction<IItemsObservationSave>) => {
      if (state.draftItemObservation) {
        state.draftItemObservation.isSaving = false
        state.draftItemObservation.error = action.payload.error
      }
    },
    itemObservationRemoveRequest: (state, action: PayloadAction<string>) => {
      state.data = state.data.map(itemObservation => {
        if (itemObservation.id !== action.payload) return itemObservation;

        return {
          ...itemObservation,
          isDeleting: true
        }
      })
    },
    itemObservationRemoveSuccess: (state, action: PayloadAction<string>) => {
      state.data = state.data.filter(itemObservation => itemObservation.id !== action.payload)
    },
    itemObservationRemoveFailure: (state, action: PayloadAction<IItemObservationRemoveFailureActionPayload>) => {
      state.data = state.data.map(itemObservation => {
        if (itemObservation.id !== action.payload.itemObservationId) return itemObservation;

        return {
          ...itemObservation,
          isDeleting: false,
          error: action.payload.error
        }
      })
    },
  }
})

// Action creators are generated for each case reducer function
export const {
  itemsObservationsListRequest,
  itemsObservationsListSuccess,
  itemsObservationsListFailure,
  startEditingItemObservation,
  itemObservationDraftUpdate,
  itemsObservationsSaveRequest,
  itemsObservationsSetPagination,
  itemsObservationsSaveSuccess,
  itemsObservationsSaveFailure,
  itemObservationRemoveRequest,
  itemObservationRemoveSuccess,
  itemObservationRemoveFailure,
  stopEditingItemObservation


} = itemsObservationsSlice.actions

export default itemsObservationsSlice.reducer